const ITEMS = [
  "Demolizioni · Murature · Impianti · Finiture",
  "Sopralluogo e preventivo chiaro",
  "Un cantiere ordinato, una casa da vivere",
  "Sede a Nibionno — senza confini rigidi",
];

const Marquee = () => (
  <div data-testid="editorial-marquee" className="bg-terracotta text-ivory overflow-hidden py-4 select-none" aria-hidden="true">
    <div className="animate-marquee flex whitespace-nowrap w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center">
              <span className="font-display text-sm md:text-base tracking-[0.25em] uppercase px-8">
                {item}
              </span>
              <span className="w-1.5 h-1.5 bg-ivory/60 rotate-45" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
